var map = {
	"./annelie-baensch-avatar.jpg": "a926",
	"./annelie-baensch.jpg": "c5db",
	"./christiane-sohn-avatar.jpg": "f7e1",
	"./christiane-sohn.jpg": "43d0",
	"./frank-trettin-avatar.jpg": "dfae",
	"./karl-kratz-avatar.jpg": "e286",
	"./karl-kratz.jpg": "aca7",
	"./karl-kratz.png": "fb29",
	"./katja-wolter-avatar.jpg": "1b87",
	"./katja-wolter.jpg": "85b5",
	"./martin-horst-avatar.jpg": "97ad",
	"./martin-horst.jpg": "e13b",
	"./maximilian-block-avatar.jpg": "f2ee",
	"./maximilian-block.jpg": "1128",
	"./rima-rifai-avatar.jpg": "9a6f",
	"./rima-rifai.jpg": "c0ab",
	"./sarah-weitnauer-avatar.jpg": "00ed",
	"./sarah-weitnauer.jpg": "8a46",
	"./sven-deutschlaender-avatar.jpg": "552c",
	"./sven-deutschlaender.jpg": "5171",
	"./tom-alby-avatar.jpg": "d2bb",
	"./tom-alby.jpg": "56bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5f4b";